import * as Types from '../../../../../packages/graphql/generated';

import { DocumentNode } from 'graphql';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';

export type ModelTypeQueryVariables = {
  name: Types.Scalars['String'];
};


export type ModelTypeQuery = (
  { __typename: 'Query' }
  & { modelType: (
    { __typename: 'ModelType' }
    & Pick<Types.ModelType, 'type' | 'id'>
  ) }
);


export const ModelTypeDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ModelType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"modelType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idOrName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}}]};

/**
 * __useModelTypeQuery__
 *
 * To run a query within a React component, call `useModelTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelTypeQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useModelTypeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ModelTypeQuery, ModelTypeQueryVariables>) {
        return ApolloReactHooks.useQuery<ModelTypeQuery, ModelTypeQueryVariables>(ModelTypeDocument, baseOptions);
      }
export function useModelTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ModelTypeQuery, ModelTypeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ModelTypeQuery, ModelTypeQueryVariables>(ModelTypeDocument, baseOptions);
        }
export type ModelTypeQueryHookResult = ReturnType<typeof useModelTypeQuery>;
export type ModelTypeLazyQueryHookResult = ReturnType<typeof useModelTypeLazyQuery>;
export type ModelTypeQueryResult = ApolloReactCommon.QueryResult<ModelTypeQuery, ModelTypeQueryVariables>;